module.exports = __webpack_public_path__ + "static/media/Artboard10.488f8cd1.png";